export default "__VITE_ASSET__BjW69bI5__"